import api from './api'

const TeamTaskDataprovider = {
  getTeamTaskDetails(params = {}) {
    return api.query('/crmtt/api/Issue/Detail', { params })
  },
  updatePriority(data) {
    return api.put('/crmtt/api/Issue/Priority', data)
  },
  saveForm(params) {
    return api.put('/crmtt/api/Issue/Component', params)
  },
  getTeamTaskDataTable(params = {}) {
    return api.post('/crmtt/api/Issue/list', params )
  },
  changeTaskStatus(payload) {
    return api.put('/crmtt/api/Issue/Status', payload)
  },
  downloadExcel(params = {}){
    return api.post('crmtt/api/Issue/ExportToXlsxListIssue', params )
  }
}

export default TeamTaskDataprovider
